/**
 * 全站路由配置
 * 代码中路由统一使用path属性跳转
 */
import Vue from 'vue'
import Router from 'vue-router'
import {request} from '@/utils/httpRequest'
import api from '@/utils/api'
import {isURL} from '@/utils/validate'
import {refreshDictList} from '@/utils/dictUtils'

Vue.use(Router)

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
// 开发环境不使用懒加载
const _import = require('./import-' + process.env.NODE_ENV)
// 全局路由
const globalRoutes = [
    {path: '/login', component: _import('modules/sys/login/login'), name: 'login', meta: {title: '登录'}},
    {path: '/menuHome', component: _import('menuHome'), name: 'menuHome', meta: {title: '首页'}},
    {
        path: '/academic/home/index',
        component: _import('modules/academic/home/index'),
        name: 'academicIndex',
        meta: {title: '学术研究子系统首页'}
    },
    {path: '/preview', component: _import('modules/dyygCollect/library/preview'), name: 'preview', meta: {title: '预览'}},
]

// 主入口路由
const mainRoutes = {
    path: '/',
    component: _import('main'),
    name: 'main',
    redirect: {name: 'login'},
    meta: {title: '整体布局'},
    children: [
        {path: '/404', component: _import('common/404'), name: '404', meta: {title: '404未找到'}},
        {
            path: '/academic/resourceList/resourcesDetails',
            component: _import('modules/academic/resourceList/resourcesDetails'),
            name: 'resourcesDetails',
            meta: {title: '资源详情'}
        },
    ]
}

const router = new Router({
    mode: 'history',  //去掉url中的#
    // mode: 'hash',
    scrollBehavior: () => ({y: 0}),
    isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
    routes: globalRoutes.concat(mainRoutes)
})

// 添加动态(菜单)路由
router.beforeEach((to, from, next) => {
    let token = sessionStorage.getItem("token")
    if (!token || !/\S/.test(token)) { // token为空，跳转到login登录
        if (process.env.VUE_APP_SSO_LOGIN === 'true') { // 如果是单点登录
            if (to.name === 'casLogin') { // 单点登录跳转页面获取token
                next()
            } else {
                window.location.href = `${process.env.VUE_APP_CAS_SERVER}/login?service=${process.env.VUE_APP_CLIENT_LOGIN}`
            }
        } else {
            if (fnCurrentRouteType(to, globalRoutes) === 'global') {
                next()
            } else {
                next({name: 'login'})
            }
        }
    } else if (router.options.isAddDynamicMenuRoutes) { // 如果已经包含权限
        next()
    } else {
        request(api.user.getMenus, {}, 'get').then(data => {
            if (data && data.status) {
                fnAddDynamicMenuRoutes(data.data.menuList)
                router.options.isAddDynamicMenuRoutes = true
                sessionStorage.setItem('allMenuList', JSON.stringify(data.data.menuList || []))
                sessionStorage.setItem('permissions', JSON.stringify(data.data.permissions || []))
                let dictList = JSON.parse(sessionStorage.getItem('dictList') || '[]')
                if (dictList.length == 0) {
                    refreshDictList();
                }
                // 调用 获取租户信息 方法并等待 Promise 完成
                getTenantInfo.call(router.app).then(() => {
                    next({...to, replace: true});
                }).catch(error => {
                    console.error('获取租户信息失败，继续跳转:', error);
                    next({...to, replace: true});
                });
            } else {
                sessionStorage.setItem('allMenuList', JSON.stringify([]))
                sessionStorage.setItem('permissions', JSON.stringify([]))
                next()
            }
        }).catch((e) => {
            sessionStorage.clear();//清除缓存
            router.push({path: '/'});//返回登录页
        })
    }
})

// 获取租户信息
function getTenantInfo() {
    return new Promise((resolve, reject) => {
        request(api.user.tenantProductConfigurationInfo).then(data => {
            if (data.status && data.data) {
                document.title = data.data.productName || '';
                sessionStorage.setItem('tenantInfo', JSON.stringify(data.data));
            }
            resolve();
        }).catch(error => {
            console.error('获取租户信息失败:', error);
            reject(error);
        });
    });
}

/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType(route, globalRoutes = []) {
    let temp = []
    for (let i = 0; i < globalRoutes.length; i++) {
        if (route.path === globalRoutes[i].path) {
            return 'global'
        } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
            temp = temp.concat(globalRoutes[i].children)
        }
    }
    return temp.length >= 1 ? fnCurrentRouteType(route, temp) : 'main'
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes(menuList = [], routes = []) {
    let temp = []
    for (let i = 0; i < menuList.length; i++) {
        if (menuList[i].children && menuList[i].children.length >= 1) {
            temp = temp.concat(menuList[i].children)
        }

        if (menuList[i].href && /\S/.test(menuList[i].href)) {
            menuList[i].href = menuList[i].href.replace(/[/]$/, '')
            const route = {
                path: menuList[i].href.split('?')[0],
                fullPath: menuList[i].href,
                component: null,
                name: menuList[i].href.replace(/^\//g, '').replace(/[/]/g, '-').replace(/[?]/g, '-').replace(/&/g, '-').replace(/=/g, '-'),
                meta: {
                    parentIds: menuList[i].parentIds,
                    menuId: menuList[i].id,
                    menuMetadataConfigId: menuList[i].menuMetadataConfigId || '',
                    title: menuList[i].name,
                    isDynamic: true,
                    type: menuList[i].target,
                    affix: menuList[i].affix === '1',
                    iframeUrl: ''
                }
            }
            // url以http[s]://开头, 通过iframe展示
            if (isURL(menuList[i].href)) {
                route.path = '/' + route.path
                route.meta.iframeUrl = menuList[i].href
                route['meta']['type'] = 'iframe'
            } else if (menuList[i].target === 'iframe') {
                route['meta']['iframeUrl'] = `${process.env.VUE_APP_SERVER_URL}${menuList[i].href}`
            } else {
                try {
                    if (menuList[i].href) {
                        route['component'] = _import(`modules${menuList[i].href.split('?')[0]}`) || null
                    }
                } catch (e) {
                }
            }
            routes.push(route)
        }
    }
    if (temp.length >= 1) {
        fnAddDynamicMenuRoutes(temp, routes)
    } else {
        mainRoutes.name = 'main-dynamic'
        mainRoutes.children = routes
        router.addRoute(mainRoutes)
        router.addRoute({path: '*', redirect: {name: 'menuHome'}})
        sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || []))
    }
}

export default router
